//@ts-nocheck
import * as React from 'react';
import renderHTML from 'react-render-html';
import ReactPaginate from 'react-paginate';
import { toCurrency } from '../../Common/Helpers';
import { FACT_SHEET_TABLE_PAGE_SIZE, getPageCount, getPageSlice } from './TablePaginationHelpers';

class CongressionalDistrictTable extends React.Component<Props, {}> {
    constructor(props) {
        super(props);

        this.state = {
            tableData: [],
            offset: 0
        };

        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.spending_congress !== prevProps.spending_congress) {
            this.setState({ offset: 0 }, () => {
                this.loadData();
            });
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * FACT_SHEET_TABLE_PAGE_SIZE);

        this.setState({ offset: offset }, () => {
            this.loadData();
        });
    };

    loadData() {
        if (this.props.spending_congress) {
            const all_data = [...this.props.spending_congress].sort((a, b) => (a.payment_amt_range < b.payment_amt_range) ? 1 : -1);
            const data = getPageSlice(all_data, this.state.offset, FACT_SHEET_TABLE_PAGE_SIZE);
            this.setState({ tableData: data, pageCount: getPageCount(all_data.length, FACT_SHEET_TABLE_PAGE_SIZE) });
        }
    }

    render() {
        const { spending_heading, spending_congress, start_year, current_year, spending_congress_total, spending_congress_total_range } = this.props;

        var congressTable = <div className="loading">loading <i className="fa fa-spinner"></i></div>;
        if (this.state.tableData !== undefined) {
            congressTable =
                this.state.tableData.map(function (table, index) {
                    const repName = "Rep. " + table.rep_name;
                    if (table.rep_name == "" || table.rep_name == null || table.rep_name == "Vacant") {
                        repName = "Vacant";
                    }

                    return (<tr key={index}>
                        <td style={{ "width": "10px" }}><b>{table.district_name}</b></td>
                        <td style={{ "width": "300px" }}>{repName}</td>
                        <td style={{ textAlign: "right", "width": "60px" }}>${toCurrency(table.payment_amt)}</td>
                        <td style={{ textAlign: "right", "width": "150px" }}>${toCurrency(table.payment_amt_range)}</td>
                    </tr>);
                })
        };
        if (spending_congress?.length > 0 && spending_heading !== undefined)

            return (
                <div className="row">
                    <div className="col-md-12">
                        <h3>{renderHTML(spending_heading)}</h3>
                        <table className="table">
                            <thead><tr><th style={{ "width": "300px" }} colSpan={2}>District</th>
                                <th style={{ "width": "80px", "textAlign": "right" }}>{current_year}</th>
                                <th style={{ "width": "80px", "textAlign": "right" }}>{`${start_year}-${current_year}`}</th>
                            </tr></thead>
                            <tbody>
                                {congressTable}
                                <tr><td style={{ "width": "300px" }} colSpan={2}><b>Total In-State Spending</b></td>
                                    <td style={{ "width": "80px", "textAlign": "right" }}><b>${toCurrency(spending_congress_total)}</b></td>
                                    <td style={{ "width": "80px", "textAlign": "right" }}><b>${toCurrency(spending_congress_total_range)}</b></td>
                                </tr>
                            </tbody>
                        </table>
                        <ReactPaginate previousLabel={"previous"}
                            nextLabel={"next"}
                            breakLabel={<a href="">...</a>}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} />
                    </div>
                </div>
            );
        return (<div></div>)

    }
}

export default CongressionalDistrictTable;